module.exports = __webpack_public_path__ + "static/media/intro.66393c24.mp4";